import { config } from "../../../config/config";
import type {
  GetNotificationsResponse,
  UnreadCountResponse,
} from "./notification";

// Bandeja de plataforma del SUPERADMIN. La forma de cada notificación es
// idéntica a la de gym, así que se reusan los tipos y los componentes.
const BASE_URL = `${config.API_URL}/v1/admin/platform-notifications`;

export const PLATFORM_NOTIFICATION_TYPES = [
  "APP_BANNER_PENDING",
  "GYM_SUBSCRIPTION_EXPIRING",
  "GYM_SUBSCRIPTION_EXPIRED",
  "GYM_CREATED",
] as const;

export type PlatformNotificationType =
  (typeof PLATFORM_NOTIFICATION_TYPES)[number];

const authHeaders = (token: string) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

export const getPlatformNotificationsRequest = async (
  token: string,
  params: {
    limit?: number;
    offset?: number;
    type?: string;
    unreadOnly?: boolean;
  },
): Promise<GetNotificationsResponse> => {
  const qp = new URLSearchParams();
  if (params.limit !== undefined) qp.append("limit", params.limit.toString());
  if (params.offset !== undefined)
    qp.append("offset", params.offset.toString());
  if (params.type) qp.append("type", params.type);
  if (params.unreadOnly) qp.append("unreadOnly", "true");

  const response = await fetch(`${BASE_URL}?${qp.toString()}`, {
    headers: authHeaders(token),
  });
  if (!response.ok) {
    throw new Error("Error al obtener notificaciones");
  }
  return response.json() as Promise<GetNotificationsResponse>;
};

export const getPlatformUnreadCountRequest = async (
  token: string,
): Promise<UnreadCountResponse> => {
  const response = await fetch(`${BASE_URL}/unread-count`, {
    headers: authHeaders(token),
  });
  if (!response.ok) {
    throw new Error("Error al obtener conteo de notificaciones");
  }
  return response.json() as Promise<UnreadCountResponse>;
};

export const markPlatformAsReadRequest = async (
  token: string,
  publicId: string,
): Promise<void> => {
  const response = await fetch(`${BASE_URL}/${publicId}/read`, {
    method: "PATCH",
    headers: authHeaders(token),
  });
  if (!response.ok) {
    throw new Error("Error al marcar notificación como leída");
  }
};

export const markAllPlatformAsReadRequest = async (
  token: string,
): Promise<{ count: number }> => {
  const response = await fetch(`${BASE_URL}/read-all`, {
    method: "PATCH",
    headers: authHeaders(token),
  });
  if (!response.ok) {
    throw new Error("Error al marcar todas como leídas");
  }
  return response.json() as Promise<{ count: number }>;
};
